module.exports = __webpack_public_path__ + "static/media/2048.87054540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apps/2048.png
// module id = 1156
// module chunks = 0